import { Locale, type LocalizedString } from "./Locale.js";

export const namesOfFiltrationLabels = {
	themedCakes: { [Locale.cs]: "Tematické dorty" },
} satisfies Record<string, LocalizedString>;
